import { render, staticRenderFns } from "./CoinClothing.vue?vue&type=template&id=bb1e8266"
import script from "./CoinClothing.vue?vue&type=script&lang=js"
export * from "./CoinClothing.vue?vue&type=script&lang=js"
import style0 from "./CoinClothing.vue?vue&type=style&index=0&id=bb1e8266&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports